import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import Modal from '../../../../../components/Modal';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  title: string;
  errorMessage: string;
};

const UpdateErrorDetailsModal: React.FC<Props> = ({
  showModal,
  closeModal,
  title,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const normalizedMessage = String(errorMessage ?? '').trim();

  return (
    <Modal
      title={`${t('detailedError')} - ${title}`}
      showModal={showModal}
      closeModal={closeModal}
      cancelButton={closeModal}
      onlyCloseButton
      bodyStyle={{ paddingLeft: '1rem', paddingRight: '1rem' }}
    >
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          lineHeight: 1.5,
          maxHeight: '60vh',
          overflowY: 'auto',
          fontSize: '0.95rem',
          color: theme.colors.text,
          background: theme.colors.surface,
          border: `1px solid ${theme.colors.onBackground}20`,
          borderRadius: '8px',
          padding: '1rem',
          margin: 0,
        }}
      >
        {normalizedMessage || t('unknownStatus')}
      </pre>
    </Modal>
  );
};

export default UpdateErrorDetailsModal;
